// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["assets/styles/styles","assets/styles/admin"], () => (__webpack_require__("./sources/js/scripts.js")))
__webpack_require__.O(undefined, ["assets/styles/styles","assets/styles/admin"], () => (__webpack_require__("./sources/styles/styles.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/styles/styles","assets/styles/admin"], () => (__webpack_require__("./sources/styles/admin.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
